<template>
  <GenericDocumentViewer>
    <template v-slot:menu>
      <div class="pa-3">
        <JobSelect v-model="jobId" :label="$t('servicesystem.common_objects.order.order')" externaledit hideIcon>
        </JobSelect>
      </div>
      <div class="pa-3">
        <QAutoComplete v-model="selectedDataSet" :list="dataSetOptions" :valuekey="'value'" :textkey="'text'"
          label="Report Type" disabled>
        </QAutoComplete>
      </div>
      <div class="pa-3">
        <QAutoComplete v-model="selectedTemplate" :list="templateOptions" :valuekey="'value'" :textkey="'text'"
          label="Template" disabled>
        </QAutoComplete>
      </div>
    </template>

    <template v-slot:document>
      <DevXReport :jobId="jobId" :dataSet="selectedDataSet" :templateName="selectedTemplate" />
    </template>
  </GenericDocumentViewer>
</template>


<script>
import JobSelect from "./Inputs/EntityDropdowns/JobSelect2.vue";
import ClientAPIMixin from "@/api/ClientAPIMixin";
import GenericDocumentViewer from "./GenericDocumentViewer.vue";
import DevXReport from "./DevXReport.vue";

export default {
  name: "ReportViewer",
  components: {
    JobSelect,
    GenericDocumentViewer,
    DevXReport,
  },
  mixins: [ClientAPIMixin],

  data() {
    return {
      templateOptions: [
        { text: "Default", value: null },
        { text: "ServiceReport_lille", value: "ServiceReport_lille" },
        { text: "ServiceReport_alles", value: "ServiceReport_alles" },
        { text: "ServiceReport_hk_8_editable", value: "ServiceReport_hk_8_editable" },
        { text: "ServiceReport_old", value: "ServiceReport_old" },
        { text: "ServiceReport hk 8&editable", value: "ServiceReport hk 8&editable" },
      ],
      selectedTemplate: null,
      dataSetOptions: [
        { text: "Service Report", value: "ServiceReport" },
        { text: "Check List", value: "CheckList" },
        { text: "Work Order", value: "WorkOrder" },
      ],
      selectedDataSet: "ServiceReport",
    };
  },

  methods: {},

  computed: {
    parentRouteTo() {
      const chain = this.$route.matched;
      if (chain && chain.length >= 2) {
        const parent = chain[chain.length - 2];
        if (parent && parent.name) {
          const params = { ...this.$route.params };
          delete params.templateKey;
          return { name: parent.name, params, query: { ...this.$route.query } };
        }
        return { path: chain[chain.length - 2].path, query: { ...this.$route.query } };
      }
      return { name: "Home" };
    },

    jobId: {
      get() {
        return parseInt(this.$route.params.jobId) || null;
      },
      set(v) {
        const id = Number(v) || null;
        if (id === this.jobId) return;

        // Use a NEW object; never mutate this.$route directly
        this.$router.replace({
          name: this.$route.name,
          params: { ...this.$route.params, jobId: id },
          query: { ...this.$route.query },
        });

        this.selectedTemplate = null;
      },
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
.boring:not(:hover)::before {
  background-color: transparent !important;
}
</style>